// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2E7O1","head":"Table_head__2lxR9","col":"Table_col__dpo2v"};